import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSearchPlus } from "react-icons/fa";
import { BiExit } from "react-icons/bi";
import { BookOpen } from "react-feather";
import ReactTooltip from "react-tooltip";
import Select from "react-select";
import dashboardAvatar from "../../assets/images/dashboard/1.png";
import { useTranslation } from "react-i18next";
import dropdown_icons from "../../assets/images/Fourms/dropdown_icons.svg";
import Dropdown from "react-bootstrap/Dropdown";
import edit_icon from "../../assets/images/Fourms/edit_icon.svg";
import delete_icon from "../../assets/images/Fourms/delete_icon.svg";

export const Viewleavesstudent = () => {
  const [studentListdet, setStudentListdet] = useState([]);
  const [loading, setLoading] = useState(false);
  const [className, setClassName] = useState([]);
  const [changeClass, setChangeClass] = useState("");
  const [studentsearch, setStudentsearch] = useState("");
  const [admno, setAdmno] = useState("");
  const [division, setDivision] = useState("");
  const navi = useNavigate();
  const { t } = useTranslation();

  // Static class data
  const staticClassData = [
    { class_id: "1", class_name: "Grade 1" },
    { class_id: "2", class_name: "Grade 2" },
    { class_id: "3", class_name: "Grade 3" },
    { class_id: "4", class_name: "Grade 4" },
    { class_id: "5", class_name: "Grade 5" },
    { class_id: "6", class_name: "Grade 6" },
    { class_id: "7", class_name: "Grade 7" },
    { class_id: "8", class_name: "Grade 8" },
    { class_id: "9", class_name: "Grade 9" },
    { class_id: "10", class_name: "Grade 10" },
  ];

  // Static division data
  const staticDivisionData = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
  ];

// Static leave request data
const staticLeaveData = [
  {
    id: 1,
    from_date: "23-11-2021",
    to_date: "25-11-2021",
    days: 3,
    reason: "Schooling & Transportation",
    status: "Pending",
    actions: ["View", "Update", "Cancel"],
  },
  {
    id: 2,
    from_date: "13-12-2021",
    to_date: "13-12-2021",
    days: 1,
    reason: "Transportation",
    status: "Canceled",
    actions: ["View"],
  },
  {
    id: 3,
    from_date: "13-12-2021",
    to_date: "13-12-2021",
    days: 1,
    reason: "Transportation",
    status: "Approved",
    actions: ["View", "Cancel"],
  },
  {
    id: 4,
    from_date: "13-12-2021",
    to_date: "13-12-2021",
    days: 1,
    reason: "Transportation",
    status: "Rejected",
    actions: ["View"],
  },
];

  // Initialize class options
  useEffect(() => {
    const classOptions = staticClassData.map((cls) => ({
      label: cls.class_name,
      value: cls.class_id,
    }));
    setClassName({ Class: classOptions });
  }, []);

  // Filter students based on search criteria
  // useEffect(() => {
  //   const filteredStudents = staticLeaveData.filter((student) => {
  //     const matchesName = student.student_name
  //       .toLowerCase()
  //       .includes(studentsearch.toLowerCase());
  //     const matchesAdmno = student.student_admission_num
  //       .toLowerCase()
  //       .includes(admno.toLowerCase());
  //     const matchesClass = changeClass
  //       ? student.class_name ===
  //         staticClassData.find((cls) => cls.class_id === changeClass)?.class_name
  //       : true;
  //     const matchesDivision = division
  //       ? student.class_division_name === division
  //       : true;

  //     return matchesName && matchesAdmno && matchesClass && matchesDivision;
  //   });

  //   setStudentListdet(filteredStudents);
  // }, [studentsearch, admno, changeClass, division]);

  const onChangeClass = (selectedOption) => {
    setChangeClass(selectedOption ? selectedOption.value : "");
  };

  const onChangeDivision = (selectedOption) => {
    setDivision(selectedOption ? selectedOption.value : "");
  };

  const handleClear = () => {
    setStudentsearch("");
    setAdmno("");
    setChangeClass("");
    setDivision("");
  };

  return (
    <div className="StudentList">
      <div className="main-sectionn">
        <div className="row">
          <div className="col-md-12">
            <div className="announcementCreatee">
              <label className="labelCreate">{t("My Leaves")}</label>
            </div>
          </div>
          <div className="tableCreate">
            <div className="table-responsive">
              <table className="table table-borderless newTable">
              <thead className="tableHeadd">
  <tr>
    <th>Sr.No</th>
    <th>{t("Leave From Date")}</th>
    <th>{t("Leave To Date")}</th>
    <th>{t("No of Days")}</th>
    <th>{t("Leave Mode")}</th>
    <th>{t("Status")}</th>
    <th></th>
  </tr>
</thead>


                <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    
                  
           </tr>
                  {staticLeaveData.length > 0 ? (
  staticLeaveData.map((item, index) => (
    <tr key={item.id}>
      <td className="textcol">{index + 1}</td>
      <td className="textcol">{item.from_date}</td>
      <td className="textcol">{item.to_date}</td>
      <td className="textcol">{item.days}</td>
      <td className="textcol">{item.reason}</td>
      <td className="textcol">
      <div className={`status-badge ${item.status.toLowerCase()}`}>
  {item.status}
</div>

</td>

<td>
  <Dropdown className="Common_dropDown">
    <Dropdown.Toggle className="dropdown-btn" id="dropdown-basic">
      <img src={dropdown_icons} alt="" />
    </Dropdown.Toggle>

    <Dropdown.Menu>
      {/* Always show View */}
      <Dropdown.Item>
        <Link
          to={"/Viewdetails"}
          state={item.feed_id}
          style={{ color: "black" }}
        >
          <img src={edit_icon} alt="" />
          {t("View")}
        </Link>
      </Dropdown.Item>

      {/* Show Cancel if allowed */}
      {(item.status === "Pending" || item.status === "Approved") && (
        <Dropdown.Item>
          <Link
            to={"/"}
            state={item.feed_id}
            style={{ color: "black" }}
          >
            <img src={edit_icon} alt="" />
            {t("Cancel")}
          </Link>
        </Dropdown.Item>
      )}

      {/* Show Update only for Pending */}
      {item.status === "Pending" && (
        <Dropdown.Item>
          <Link
            to={"/Viewdetailsupdate"}
            state={item.feed_id}
            style={{ color: "black" }}
          >
            <img src={edit_icon} alt="" />
            {t("Update")}
          </Link>
        </Dropdown.Item>
      )}
    </Dropdown.Menu>
  </Dropdown>
</td>

    </tr>
  ))
) : (
  


                    <tr>
                      <td colSpan="8" className="text-center py-3">
                        <p className="text-muted">
                          {t("No students found matching your criteria")}
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Viewleavesstudent;